import { atom } from 'recoil';

const makeModelStatusMessageAtom = atom({
  key: 'makeModel/statusMessages',
  default: [],
});

// Holds the { previous, updated } make and model of the most recent successful
// edit. The Make/Model filter panel lives outside the edit modal's tree, so it
// watches this atom to refresh any applied filter that still points at the
// pre-edit name (see make-model/components/makeTypeahead.jsx).
const makeModelEditedAtom = atom({
  key: 'makeModel/lastEdited',
  default: null,
});

export { makeModelStatusMessageAtom, makeModelEditedAtom };
